import { useTranslation } from 'react-i18next';

import { FormInput } from '@unified-checkout/kit-components';
import creditCardIcon from '../../assets/icons/credit-card.svg';

export function MobileCardNumber(props: any) {
  const {
    noCardLogo,
    formRegister,
    error,
    className,
    getCardLogo,
    maxLength,
    cardType,
    label,
    customStyle,
    customInputStyle,
  } = props;
  const { t } = useTranslation('card');

  return (
    <FormInput
      formRegister={formRegister}
      name={'number'}
      className={className}
      placeholder={t('CARD_NUMBER_PLACEHOLDER')}
      icon={
        getCardLogo(cardType) === '' || noCardLogo ? (
          <img
            src={creditCardIcon}
            className="w-7 h-5 object-contain"
            alt="master card icon"
          />
        ) : (
          !noCardLogo && (
            <img
              className="w-7 h-5 object-contain border-solid border rounded-md border-gray-200"
              src={getCardLogo(cardType)}
              alt={cardType}
            />
          )
        )
      }
      label={label}
      error={error}
      maxLength={maxLength}
      inputMode="numeric"
      pattern={'d*'}
      customStyle={customStyle}
      customInputStyle={customInputStyle}
    />
  );
}
